import { WatchItemDialogComponent, WatchItemDialogData } from '@watch-lists/dialogs/watch-item-dialog/watch-item-dialog.component';
import { AppDialogsService } from '@/app/services/app-dialogs.service';
import { Injectable } from '@angular/core';
import { DialogNavigations } from '@egovsolutions/angular-dialog-navigations';
import { ScrollableModal } from '@egovsolutions/angular-scrollable-modal';
import { filter } from 'rxjs/operators';
import { NewWatchListDialogComponent } from '../dialogs/new-watch-list/new-watch-list.component';

@Injectable({ providedIn: 'any' })
export class WatchListsDialogs
{
    constructor
    (
        // Dependencies

        private readonly appDialogsService: AppDialogsService,
        private readonly scrollableModal: ScrollableModal,
        private readonly dialogNavigations: DialogNavigations,
    )
    {
        this.init();
    }


    // Initialization

    public init()
    {
        this.setUpDialogNavigationRequests();
    }


    // New list

    public createList()
    {
        this.appDialogsService.signIn().pipe(filter(signedIn => !!signedIn)).subscribe(signedIn =>
        {
            const dialogRef =
                this.scrollableModal.open(NewWatchListDialogComponent, { autoFocus: true });

            this.dialogNavigations.set(dialogRef, { type: 'new-list' });
        });
    }


    // Watch account

    public watchAccount(dialogData: WatchItemDialogData)
    {
        this.appDialogsService.signIn().pipe(filter(signedIn => !!signedIn)).subscribe(signedIn =>
        {
            const dialogRef =
                this.scrollableModal.open(WatchItemDialogComponent, { data: dialogData, autoFocus: false });

            this.dialogNavigations.set(dialogRef, { type: 'watch-list' });
        });
    }


    // Dialogs navigation

    public setUpDialogNavigationRequests()
    {
        this.dialogNavigations.restore$.pipe(filter(d => d.type === 'new-list'))
            .subscribe(d => this.createList());
    }
}
